import React from 'react';
import PropTypes from 'prop-types';
import MaterialUICheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import Color from 'color';

import dagstorp from 'LegacyWeployDesignLanguage/dagstorp';

const WeployCheckbox = withStyles({
  colorSecondary: {
    color: dagstorp.colors.text.primary,
    '&:hover': {
      backgroundColor: Color(dagstorp.colors.text.primary).fade(0.88).string(),
    },
    '&$checked': {
      color: dagstorp.colors.text.primary,
      '&:hover': {
        backgroundColor: Color(dagstorp.colors.text.primary).fade(0.88).string(),
      },
    },
  },
  checked: {},
})(props => <MaterialUICheckbox {...props} />);

const Checkbox = ({
  label,
  ...rest
}) => (
  <FormControlLabel
    label={label}
    control={<WeployCheckbox {...rest} />}
  />
);

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  classes: PropTypes.object,
};

Checkbox.defaultProps = {
  classes: {},
  label: '',
};

Checkbox.CheckboxWithoutLabel = WeployCheckbox;

export default Checkbox;
